export var ON_CLOSE_MEATBALLS = 'onCloseMeatballs';
